import React, { useState ,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AdmMentor.css";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import { fetchLoggedInTeacherOption } from "../../hooks/fetchLoggedInTeacherOption";


const AdmMentorStudentDetails = () => {
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [mentors, setMentors] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentDetails, setStudentDetails] = useState(null);
  const [studentLoadError, setStudentLoadError] = useState("");
  const navigate = useNavigate();

  const handleClear = () => {
    setSelectedStudent(null);
    setStudentDetails(null);
    setStudentLoadError("");
  };



  // useEffect(() => {
  //   const fetchMentors = async () => {
  //     try {
  //       const response = await fetch(
  //         `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=1&branchId=1`
  //       );
  //       const data = await response.json();
  //       if (data && data.data) {
  //         // Mapping data to match React Select options format
  //         const formattedMentors = data.data.map((mentor) => ({
  //           value: mentor.id,
  //           label: mentor.employeeName,
  //         }));
  //         setMentors(formattedMentors);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching mentors:", error);
  //     }
  //   };

  //   fetchMentors();
  // }, []);

  useEffect(() => {
    const loadLoggedInMentor = async () => {
      try {
        const loggedInMentor = await fetchLoggedInTeacherOption();

        if (loggedInMentor) {
          setMentors([loggedInMentor]);
          setSelectedMentor(loggedInMentor);
        } else {
          setMentors([]);
          setSelectedMentor(null);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
        setMentors([]);
        setSelectedMentor(null);
      }
    };

    loadLoggedInMentor();
  }, []);

  const branchId = localStorage.getItem("branchId");
  const orgId = localStorage.getItem("orgId");
  const academicYearId = localStorage.getItem("academicSessionId");

  useEffect(() => {
    if (!selectedMentor) return;

    const fetchStudents = async () => {
      try {
        setStudentLoadError("");
        const url = `${ApiUrl.apiurl}Mentor/mentorWiseStudentList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${selectedMentor.value}`;
        const response = await fetch(url);
        const contentType = response.headers.get("content-type") || "";

        if (!response.ok) {
          const rawError = await response.text();
          throw new Error(
            rawError && rawError.trim().startsWith("<")
              ? "Mentor-wise student list API failed on the server."
              : rawError || "Unable to fetch students."
          );
        }

        if (!contentType.includes("application/json")) {
          throw new Error("Student API returned an unexpected response.");
        }

        const data = await response.json();

        if (data && data.data) {
          const formattedStudents = data.data.map((student) => ({
            value: student.student_id, // Corrected key mapping
            label: student.student_name, // Corrected key mapping
          }));
          setStudents(formattedStudents);
        } else {
          setStudents([]);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        setStudents([]);
        setSelectedStudent(null);
        setStudentDetails(null);
        setStudentLoadError(error.message || "Unable to fetch students.");
      }
    };

    fetchStudents();
  }, [selectedMentor, academicYearId, orgId, branchId]);

  // Fetch student details when a student is selected
  useEffect(() => {
    if (!selectedStudent) return;

    const fetchStudentDetails = async () => {
      try {
        const url = `${ApiUrl.apiurl}STUDENT_DETAILS/StudentDetailsList/${selectedStudent.value}/`;
        const response = await fetch(url);
        const data = await response.json();

        if (data && data.data) {
          setStudentDetails(data.data);
        }
      } catch (error) {
        console.error("Error fetching student details:", error);
      }
    };

    fetchStudentDetails();
  }, [selectedStudent]);


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <h4 className="text-center fw-bold">Student Profile</h4>

              {/* Buttons */}
              <div className=" row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/staff/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* Mentor and Student Dropdowns */}
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      {/* Mentor Dropdown */}
                      <div className="col-12 col-md-4 mb-4">
                        <label className="form-label">Mentor</label>
                        <Select
                          id="mentor"
                          options={mentors}
                          value={selectedMentor}
                          isDisabled
                          placeholder="Logged-in mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>

                      {/* Student Dropdown */}
                      <div className="col-12 col-md-4 mb-4">
                        <label className="form-label">Student</label>
                        <Select
                          id="student-name"
                          classNamePrefix="student-name-dropdown"
                          // className="flex-grow-1"
                          options={students} // Dropdown values appear only after selecting a mentor
                          placeholder="Select Student"
                          isDisabled={!selectedMentor} // Disables dropdown until a mentor is selected
                          value={selectedStudent}
                          onChange={setSelectedStudent}
                        />
                        {studentLoadError ? (
                          <small className="text-danger d-block mt-2">
                            {studentLoadError}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Student Details Table */}
              <div className="container-fluid mt-4 ">
                <div className="table-responsive">
                  <table className="table custom-table">
                    <tbody>
                      <tr>
                        <td className="fw-bold text-start">Student Name</td>
                        <td className="text-start">
                          {studentDetails?.studentname || " "}
                        </td>
                        <td className="fw-bold text-start">Admission No</td>
                        <td className="text-start">
                          {studentDetails?.admission_no || " "}
                        </td>
                        <td className="fw-bold text-start">Class/Section</td>
                        <td className="text-start">
                          {studentDetails?.class || " "}{" "}
                          {studentDetails?.sectionname || ""}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold text-start">Father Name</td>
                        <td className="text-start">
                          {studentDetails?.father_name || " "}
                        </td>
                        <td className="fw-bold text-start">Father Mobile No</td>
                        <td className="text-start">
                          {studentDetails?.father_contact_number || " "}
                        </td>
                        <td className="fw-bold text-start">Father Email</td>
                        <td className="text-start">
                          {studentDetails?.father_email || " "}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold text-start">Mother Name</td>
                        <td className="text-start">
                          {studentDetails?.mother_name || " "}
                        </td>
                        <td className="fw-bold text-start">Mother Mobile No</td>
                        <td className="text-start">
                          {studentDetails?.mother_contact_number || " "}
                        </td>
                        <td className="fw-bold text-start">Mother Email</td>
                        <td className="text-start">
                          {studentDetails?.mother_email || " "}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold text-start">
                          Student Mobile No
                        </td>
                        <td className="text-start">
                          {studentDetails?.student_mobile_no || " "}
                        </td>
                        <td className="fw-bold text-start">Student Email</td>
                        <td className="text-start">
                          {studentDetails?.student_email || " "}
                        </td>
                        <td colSpan="2"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmMentorStudentDetails;
